import { BufferAttribute, BufferGeometry } from "three";
import { LidarPointCloudHeat } from "../types/laserScanScene";
import Delaunator from "delaunator";

export const getLidarPointCloudHeatData = ({
  id,
  dataUrl,
}: LidarPointCloudHeat) => {
  return {
    id,
    dataUrl,
    title: "t",
    description: "d",
    dataFormat: "csv",
  };
};
interface GeometryData {
  position: Float32Array;
  color: Float32Array;
  pointThicknessMap: Float32Array;
  pointQuadrantMap: Float32Array;
  pointRowMap: Float32Array;
  pointMainZoneMap: Float32Array;
}
//      INFO: Fatih cant use Delunator in worker thread
//      So, we're using delunator in here. Not in worker thread.

export const calculateDelaunayMeshByUsingDelunator = (
  points3dFull2: Record<string, number[]>,
  geometryData: GeometryData,
) => {
  let totalVertices = 0;
  Object.values(points3dFull2).forEach((points) => {
    totalVertices += points.length;
  });

  const geometry = new BufferGeometry();
  const positions = new Float32Array(totalVertices * 3);
  const colors = new Float32Array(totalVertices * 3);
  const pointThicknessMap = new Float32Array(totalVertices);
  const pointQuadrantMap = new Float32Array(totalVertices);
  const pointRowMap = new Float32Array(totalVertices);
  const pointMainZoneMap = new Float32Array(totalVertices);

  const indices: number[] = [];
  let vertexOffset = 0;

  Object.entries(points3dFull2).forEach(([section, pointIndices]) => {
    const points3d = pointIndices.map((index) => ({
      x: geometryData.position[index * 3],
      y: geometryData.position[index * 3 + 1],
      z: geometryData.position[index * 3 + 2],
    }));

    if (points3d.length === 0) return;

    points3d.forEach((point, i) => {
      const originalIndex = pointIndices[i];

      positions[vertexOffset * 3 + i * 3] = point.x;
      positions[vertexOffset * 3 + i * 3 + 1] = point.y;
      positions[vertexOffset * 3 + i * 3 + 2] = point.z;

      colors[vertexOffset * 3 + i * 3] = geometryData.color[originalIndex * 3];
      colors[vertexOffset * 3 + i * 3 + 1] =
        geometryData.color[originalIndex * 3 + 1];
      colors[vertexOffset * 3 + i * 3 + 2] =
        geometryData.color[originalIndex * 3 + 2];

      pointThicknessMap[vertexOffset + i] =
        geometryData.pointThicknessMap[originalIndex];
      pointQuadrantMap[vertexOffset + i] =
        geometryData.pointQuadrantMap[originalIndex];
      pointRowMap[vertexOffset + i] = geometryData.pointRowMap[originalIndex];
      pointMainZoneMap[vertexOffset + i] =
        geometryData.pointMainZoneMap[originalIndex];
    });

    const points2D = points3d.map((v) => {
      if (section === "bottom") return [v.x, v.y];
      if (section !== "west" && section !== "east") return [v.x, v.z];
      return [v.y, v.z];
    });

    const delaunay = new Delaunator(points2D.flat());

    for (let i = 0; i < delaunay.triangles.length; i++) {
      indices.push(delaunay.triangles[i] + vertexOffset);
    }

    vertexOffset += points3d.length;
  });

  geometry.setAttribute("position", new BufferAttribute(positions, 3));
  geometry.setAttribute("color", new BufferAttribute(colors, 3));
  geometry.setAttribute(
    "pointThicknessMap",
    new BufferAttribute(pointThicknessMap, 1),
  );
  geometry.setAttribute(
    "pointQuadrantMap",
    new BufferAttribute(pointQuadrantMap, 1),
  );
  geometry.setAttribute("pointRowMap", new BufferAttribute(pointRowMap, 1));
  geometry.setAttribute(
    "pointMainZoneMap",
    new BufferAttribute(pointMainZoneMap, 1),
  );
  geometry.setIndex(indices);

  geometry.computeVertexNormals();

  return geometry;
};
